import { Link } from "react-router-dom";
import { photos } from "@/mocks/media";

export default function PhotoGallery() {
  return (
    <section className="py-16 bg-background-100">
      <div className="max-w-screen-xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2
              className="text-2xl md:text-3xl font-bold text-foreground-950"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              写真精选
            </h2>
            <p className="mt-2 text-foreground-600 text-sm">佐佐木希精美写真欣赏</p>
          </div>
          <Link
            to="/category/photo"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap flex items-center gap-1"
          >
            查看全部 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {photos.map((photo, index) => {
            const spanClass =
              index === 0
                ? "lg:col-span-2 lg:row-span-2"
                : index === 1
                  ? "lg:col-span-2"
                  : "";
            return (
              <Link
                key={photo.id}
                to="/category/photo"
                className={`group relative overflow-hidden rounded-lg ${spanClass}`}
              >
                <div className="aspect-[3/4] w-full overflow-hidden">
                  <img
                    src={photo.imageUrl}
                    alt={photo.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    title={`佐佐木希写真 - ${photo.title}`}
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-5">
                  <div>
                    <p className="text-white text-sm font-medium">{photo.title}</p>
                    <p className="text-white/70 text-xs mt-1">{photo.description}</p>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}